import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { VesselTypePayload, VesselTypeResponse } from "@/types/interface/vessel-type";

async function createVesselType(payload: VesselTypePayload) {
  return await http.post<APIResponse<VesselTypeResponse>>("vessel-type/create", payload);
}

async function updateVesselType(idVeselType = '', payload: VesselTypePayload) {
  return await http.patch<APIResponse<VesselTypeResponse>>(`vessel-type/update?id=${idVeselType}`, payload);
}

async function getVesselType(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<VesselTypeResponse>>(`vessel-type?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findVesselType(idVeselType = "") {
  return await http.get<APIResponse<VesselTypeResponse>>(`vessel-type/detail?id=${idVeselType}`);
}

async function deleteVesselType(idVeselType = "") {
  return await http.delete<APIResponse<VesselTypeResponse>>(`vessel-type/delete?id=${idVeselType}`);
}

export default {
  createVesselType,
  updateVesselType,
  getVesselType,
  findVesselType,
  deleteVesselType
};